import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { type: string, title: string, text: string, text2: string }) { }



  ngOnInit(): void {
    console.log(this.data)
  }

  onNoClick(): void {
    // this.openDialogLogOut()
  }



}
